document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("product-modal-dialog")) {
    customElements.define(
      "product-modal-dialog",
      class ProductModalDialog extends customElements.get("modal-dialog") {
        constructor() {
          super();
          this.closeSubscriptionButton =
            this.querySelector(`[data-close-modal]`);
          this.closeSubscriptionButton.addEventListener("click", () => {
            this.hide();
            this.selectSubscription();
          });
          this.subscriptionVariantSelects =
            this.querySelector(
              `[data-close-modal]`
            ).dataset.subscriptionVaraintId;
        }
        connectedCallback() {
          super.connectedCallback();
        }

        show(opener) {
          super.show(opener);
        }
        hide() {
          super.hide();
        }
        selectSubscription() {
          const subscribeVariant = document.querySelector(`.frequency-box[data-variant-id="${this.subscriptionVariantSelects}"]`);
          if (!subscribeVariant) {
            this.selectPlanPickerSubscription();
            return;
          }
          const variantWrap = subscribeVariant.closest('.variant-wrap');
          if (!variantWrap) {
            return;
          }
          const radioInput = variantWrap.querySelector('input[type="radio"]');
          if (!radioInput) {
            return;
          }
          radioInput.click();
        }
        // Plan picker (single-variant model): there is no per-frequency variant to look up,
        // so select its first subscription card, the one it lists first. Only the picker of
        // this popup's own section (the modal id carries the section id); products without
        // a plan picker keep the behaviour above untouched.
        selectPlanPickerSubscription() {
          const picker = Array.from(document.querySelectorAll('buy-box-value.plan-picker')).find(
            (el) => el.dataset.section && this.id.includes(el.dataset.section)
          );
          const radioInput = Array.from(picker?.querySelectorAll('input[type="radio"]') || []).find(
            (input) => input.dataset.sellingPlanId && !input.disabled
          );
          if (radioInput) radioInput.click();
        }
      }
    );
  }
});
